import React from 'react'
import "../Product/Intro.css";  
import { useLanguage } from "../LanguageContext";
const Intusty2 = () => {
  const { language } = useLanguage();
  return (
    <div className="hardware-container">
      <div className="content">
        <h2 className="heading"><span>Industry We Serve</span></h2>
        <p className="description">
          {language === "en" ? (
            <>
              <strong>
                Delivering IT solutions with purpose — tailored for every
                industry we touch.
              </strong>
              <br />
              <br />
              At Proscope, we understand that every industry faces unique
              challenges — and that technology is most effective when it aligns
              with real-world needs. That’s why we take an industry-centric
              approach to every solution we design. From high-performance
              infrastructure to smart cloud platforms and secure digital
              environments, we help organizations thrive in their own context,
              at their own pace.
              <br />
              <br />
            </>
          ) : (
            <>
              <strong>อุตสาหกรรมที่เราให้บริการ</strong>
              <br />
              <strong>
                โซลูชันไอทีที่ออกแบบอย่างเข้าใจ — เพื่อทุกอุตสาหกรรมที่เราใส่ใจ
              </strong>
              <br />
              <br />
              ที่ Proscope เราเชื่อว่าแต่ละอุตสาหกรรมมีความต้องการเฉพาะ
              และเทคโนโลยีจะมีความหมายก็ต่อเมื่อสามารถตอบโจทย์การใช้งานจริงได้อย่างแท้จริง
              เราจึงพัฒนาโซลูชันไอทีโดยยึดตามบริบทของแต่ละธุรกิจ
              ช่วยให้องค์กรก้าวหน้าในแบบของตัวเอง
              ทั้งด้านโครงสร้างพื้นฐานที่แข็งแกร่ง ระบบคลาวด์อัจฉริยะ
              และระบบที่มีความปลอดภัยสูง
              <br />
              <br />
            </>
          )}
        </p>
        <div className="horizontal-text-container">
          <p>About Us</p>
          <p>/</p>
          <p>Industry We Serve</p>
        </div>
      </div>
    </div>
  );
};

export default Intusty2